import { NumericFormat } from 'react-number-format';
import { ReactComponent as Check } from '../../../assets/icons/Check.svg';

import classes from './NumberInput.module.scss';

const NumberInput = ({
  className,
  classNameFormat,
  value,
  error,
  onChange,
  validated,
  prefix,
  placeholder,
  thousandSeparator = true,
  name,
  disabled,
  maxValue,
  onBlur,
}) => {
  let classFormat = [error ? 'input-error' : 'input-text', classes.content, 'medium-16'];
  if (classNameFormat) {
    classFormat.push(classNameFormat);
  }
  const withValueLimit = ({ floatValue }) => {
    if (maxValue) {
      return floatValue <= maxValue;
    }
    return true;
  };
  return (
    <div className={`${classes.div} ${className}`}>
      <NumericFormat
        onBlur={onBlur}
        disabled={disabled}
        className={classFormat.join(' ')}
        value={value}
        name={name}
        // Corregido: Eliminado console.log innecesario que causaba warnings en consola
        onValueChange={values => onChange(values.floatValue)}
        prefix={prefix || prefix === '' ? prefix : '$'}
        allowedDecimalSeparators={[',']}
        thousandSeparator={thousandSeparator}
        placeholder={placeholder}
        isAllowed={withValueLimit}
        allowLeadingZeros
      />
      {validated && <Check className={classes.icon} />}
    </div>
  );
};

export default NumberInput;
